export default __webpack_public_path__ + "static/CurvedLinesBelowData-ae2df16a9775b6684f3a3b3f614d99fc.svg";